import { CellGlobalActions } from '@components/organisms/Datatable/cells/CellGlobalActions';

const tableSchemaBase = [
	{
		accessor: 'project',
		title: 'global.project',
		sortable: true,
		defaultVisible: true,
		fixed: true,
		footerType: 'sumProjectsProductions',
	},
	{
		accessor: 'site',
		title: 'global.site',
		sortable: true,
		defaultVisible: true,
		fixed: true,
		footerType: 'sumSitesProductions',
	},
	{
		accessor: 'startDate',
		title: 'global.startDate',
		sortable: true,
		defaultVisible: true,
		fixed: true,
	},
	{
		accessor: 'production',
		title: 'global.quantity',
		defaultVisible: true,
		fixed: true,
		footerType: 'sumProductions',
	},
	{
		accessor: 'tokenEquivalent',
		title: 'global.tokenEquivalent',
		defaultVisible: true,
		footerType: 'sumTokenEquivalents',
	},
	{
		accessor: 'verified',
		title: 'global.verification',
		sortable: true,
		type: 'verifiedStatus',
		defaultVisible: true,
		footerType: 'sumVerifiedProductions',
	},
	{
		accessor: 'mintStatus',
		title: 'global.mintStatus',
		type: 'mintStatus',
		sortable: true,
		defaultVisible: true,
		footerType: 'sumMintStatusProductions',
	},
	{
		accessor: 'entity',
		title: 'global.producer',
		sortable: true,
		defaultVisible: false,
	},
	{
		accessor: 'meterPoint',
		title: 'global.meterPoint',
		sortable: true,
		defaultVisible: false,
	},
	{
		accessor: 'createdAt',
		title: 'global.createdAt',
		sortable: true,
		defaultVisible: false,
	},
	{
		accessor: 'proof',
		title: 'global.proof',
		defaultVisible: false,
	},
	{
		accessor: 'verifiedBy',
		title: 'global.verifiedBy',
		defaultVisible: false,
	},
	{
		accessor: 'quantityCheck',
		title: 'global.qtyAlert',
		type: 'QuantityCheck',
		sortable: true,
		defaultVisible: true,
		fixed: true,
	},
	{
		type: 'productionsActions',
		accessor: 'actions',
		title: <CellGlobalActions />,
		resizable: true,
		defaultVisible: true,
	},
];

export { tableSchemaBase };
